import type {
  CoOwnerInvestmentAccountRequest,
  CoOwnerStepData,
  CoOwnerStepRequest,
} from './models';

import { saveOnboardingStep } from './onboarding-step';

const saveCoOwnerStep = saveOnboardingStep<CoOwnerStepData, CoOwnerStepRequest>(
  'No se pudo guardar el cotitular',
);

const saveCoOwnerInvestmentAccountStep = saveOnboardingStep<
  CoOwnerStepData,
  CoOwnerInvestmentAccountRequest
>('No se pudo guardar la cuenta de inversión del cotitular');

export const createCoOwner = (body: CoOwnerStepRequest) =>
  saveCoOwnerStep('post', '/onboarding/coOwner', body);

export const updateCoOwner = (body: CoOwnerStepRequest) =>
  saveCoOwnerStep('put', '/onboarding/coOwner', body);

export const updateCoOwnerInvestmentAccount = (
  body: CoOwnerInvestmentAccountRequest,
) =>
  saveCoOwnerInvestmentAccountStep(
    'put',
    '/onboarding/investment/account/person',
    body,
  );
